module.exports = __webpack_public_path__ + "static/img/1708.9e1fe84.png";